<template>
  <div>
    <div class="manualReply">
      <!-- 表单查询 -->
      <div class="headForm">
        <h4 style="color: #2e3458; font-size: 16px; font-weight: bold">
          手动回评
        </h4>
        <div style="padding-top: 20px">
          <inputForm :inputData="inputData" @toParentVal="queryList" ref="searchForm" v-if="!venderType"></inputForm>
          <inputForm :inputData="inputData1" @toParentVal="queryList" ref="searchForm" v-if="venderType"></inputForm>
        </div>
      </div>

      <div class="content">
        <!-- 表格内容 -->
        <div class="tableWrapper">
          <!-- 头部按钮 -->
          <div class="headBtn">
            <div class="leftBtn">
              <button class="b1" v-zoom="{ from: pageName, name: '批量回复评价' }" @click.prevent="handleReview">
                批量回复评价
              </button>
              <button class="b2" v-zoom="{ from: pageName, name: '发送短信' }" @click.prevent="handleSendSms">
                发送短信
              </button>
              <button class="b2" v-zoom="{ from: pageName, name: '按查询结果发送短信' }" @click.prevent="handleSearchSendSms">
                按查询结果发送短信
              </button>
              <button class="b5" v-zoom="{ from: pageName, name: '批量加入黑名单' }" @click="handleAddBackList">
                批量加入黑名单
              </button>
            </div>
          </div>

          <!-- 表格 -->
          <el-table
            ref="table"
            :data="tableData"
            row-key="commentId"
            v-loading="loading"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            @selection-change="handleSelectionChange"
            style="width: 100%; border: 1px solid #eee; margin-top: 20px"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column type="selection" reserve-selection width="55"></el-table-column>
            <el-table-column label="商品信息">
              <template slot-scope="scope">
                <div class="info">
                  <div class="right">
                    <a :href="scope.row.skuIdUrl" target="_blank">
                      <p class="tit">{{ scope.row.skuName }}</p>
                    </a>
                    <p class="details">
                      <span style="margin-right: 12px">skuid:{{ scope.row.skuId }}</span>
                      <span>订单号：{{ scope.row.orderId }}</span>
                    </p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="买家评价" width="420px">
              <template slot="header">
                <span>买家评价</span>
                <span style="color: #7f85e9; cursor: pointer" @click="switchShowBugyer">{{ !isShowAllBuyer ? "（展开全部）" : "（收起全部）" }}</span>
              </template>
              <template slot-scope="scope">
                <div class="evaluate">
                  <el-tooltip class="item" effect="light" :content="scope.row.content" placement="top-start">
                    <div class="desc" v-if="isShowAllBuyer">
                      {{ scope.row.content }}
                    </div>
                    <div v-else class="desc" :class="scope.row.count > 0 ? 'one-ellipsis' : 'two-ellipsis'">
                      {{ scope.row.content }}
                    </div>
                  </el-tooltip>
                  <div class="media-list" v-if="scope.row.count > 0">
                    <div class="video-list">
                      <div class="video-item" v-for="(item, vIndex) in scope.row.videoList" :key="vIndex" @click="showVideoDialog(item)">
                        <img :src="item.mainUrl" alt="" />
                        <img class="mask" src="@/assets/images/video-mask.png" alt="" />
                      </div>
                    </div>
                    <div class="pic-list">
                      <viewer :images="scope.row.imageList">
                        <img
                          :style="{
                            marginLeft: index === 0 ? scope.row.videoLenth * 68 + 'px' : '',
                          }"
                          v-for="(src, index) in scope.row.imageList"
                          v-show="isShowAllBuyer || (!isShowAllBuyer && index < scope.row.limit)"
                          :key="index"
                          :src="src"
                          alt=""
                        />
                        <div class="total-box" v-if="scope.row.count > 6 && !isShowAllBuyer">
                          共{{ (scope.row.imageList && scope.row.imageList.length) || 0 }}张
                        </div>
                      </viewer>
                    </div>
                  </div>
                  <p class="star">
                    <star :key="scope.row.$index" :score="scope.row.score"></star>
                    <span>{{ scope.row.score }}.0星</span>
                  </p>
                  <p class="user">
                    <span class="name">{{ scope.row.desensitizePin }}</span>
                    <span class="time">{{ scope.row.creationTime }}</span>
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="回评">
              <template slot="header">
                <span>回评</span>
                <span style="color: #7f85e9; cursor: pointer" @click="toggleShow" v-if="!isShowAll">（展开全部）</span>
                <span style="color: #7f85e9; cursor: pointer" @click="toggleShow" v-else>（收起全部）</span>
              </template>
              <template slot-scope="scope">
                <div class="review">
                  <div class="review" v-show="indexI == '0' || isShowAll" v-for="(itemI, indexI) in scope.row.replyVoList" :key="indexI">
                    <p class="desc">回评内容: {{ itemI.content }}</p>
                    <!-- <p class="star"></p> -->
                    <p class="user">
                      <span class="name">{{ itemI.nickName }}</span>
                      <span class="time">{{ $decrypt.format(itemI.creationTime) }}</span>
                    </p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span
                  class="operation"
                  v-zoom="{ from: pageName, name: '回复评价' }"
                  v-if="scope.row.isVenderReply == 0"
                  @click="singleReply(scope.row)"
                >
                  回复评价
                </span>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="size"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 发送短信抽屉 -->
    <send-sms
      :drawer="drawer"
      :checkData="checkData"
      :count="checkCount"
      :sendType="sendType"
      :dataFrom="8"
      @close="drawerClose"
      :searchForm="searchFormData"
      taskName="手动回评"
    >
    </send-sms>
    <!-- 批量回评 -->
    <my-popup title="批量回评" width="570" :flag="replyState" @close="replyChange">
      <div class="replyContainer">
        <div class="item">
          <span class="s">回评数量：</span>
          <span style="color: #fe4d45">{{ reviewNumber }}</span
          >（不包含已评价的）
        </div>
        <div class="item">
          <span class="s">回评内容：</span>
          <div class="right">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入回评内容"
              maxlength="200"
              show-word-limit
              style="font-size: 14px"
              v-model="replyContent"
            >
            </el-input>
            <div class="desc">
              <i class="el-icon-warning" style="color: #fe8f8a; margin-right: 8px"></i>注：此回复不是给客户发短信，而是直接回到商品详情页
            </div>
          </div>
        </div>
        <div class="footBtns">
          <button class="cancelBtn" @click="replyChange">取消</button>
          <button class="confirmBtn" @click="handleBatchReply">确认</button>
        </div>
      </div>
    </my-popup>
    <!-- 单条回复评价 -->
    <my-popup title="回评" width="570" :flag="singleReplyState" @close="singleReplyChange">
      <div class="replyContainer">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入回评内容"
          maxlength="200"
          show-word-limit
          style="margin-bottom: 16px; font-size: 14px"
          v-model="singleReplyContent"
        >
        </el-input>
        <div class="footBtns">
          <button class="cancelBtn" @click="singleReplyChange">取消</button>
          <button class="confirmBtn" @click="handleEditsingleReply">
            确认
          </button>
        </div>
      </div>
    </my-popup>
    <!-- 加入黑名单 -->
    <my-popup title="提示" width="400" :flag="joinBackListShow" @close="joinBackListShow = false">
      <div class="JoinBackList">
        <div class="tipsBox">
          <img
            src="../../assets/images/tips_icon.png"
            style="width: 22px;
    height: 22px;s"
            class="tips"
          />
          <span>确定拉黑订单吗？</span>
        </div>
        <div class="btnBox">
          <button class="cancelBtn" @click="joinBackListShow = false">
            取消
          </button>
          <button class="confirmBtn" @click="handleJoinBackList">确认</button>
        </div>
      </div>
    </my-popup>
    <!-- 视频放大组件 -->
    <transition name="fade">
      <video-play v-show="showVideo" :visible="showVideo" :videoData="videoData" @onClose="showVideo = false"></video-play>
    </transition>
  </div>
</template>

<script>
import videoPlay from "@/components/video-play";
import { mapState } from "vuex";
import inputForm from "../../components/inputForm";
import star from "@/components/star";
import myPopup from "@/components/myPopup";
import sendSms from "./components/sendSms";
import { getPopCommentReplyList, replyCommentBatch } from "@/api/serviceCenter/popCommentController";
import { insertBlack } from "@/api/smsBlackList";

export default {
  components: {
    inputForm,
    videoPlay,
    star,
    myPopup,
    sendSms,
  },
  data() {
    return {
      imagesList: [],
      isShowAll: false,
      isShowAllBuyer: false,
      pageName: "售后中心-手动回评",
      inputData: [
        // 传入组件的表单需要的数据格式
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
        },
        {
          name: "订单编号:",
          val: "orderId",
          placeholder: "请输入订单编号",
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
        },
        {
          name: "买家账号:",
          val: "nickName",
          placeholder: "请输入买家账号",
        },
        {
          name: "回评状态:",
          val: "isVenderReply",
          selectArr: [
            { label: "未回复", id: 0 },
            { label: "京东后台回复", id: 1 },
            { label: "店长手动回复", id: 2 },
            { label: "店长自动回复", id: 3 },
          ],
        },
        {
          name: "评分等级:",
          val: "score",
          selectArr: [
            { label: "差评", id: 1 },
            { label: "中评", id: 2 },
            { label: "好评", id: 3 },
          ],
        },
        {
          name: "评价时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "评价关键词:",
          val: "keyWord",
          placeholder: "请输入评价关键词，多个用','隔开",
        },
        {
          name: "评价内容:",
          val: "contentType",
          selectArr: [
            { label: "全部", id: "" },
            { label: "仅文字", id: 1 },
            { label: "含图片", id: 2 },
            { label: "含视频", id: 3 },
          ],
        },
        {
          name: "评价字数:",
          iptArr: [
            { val: "wordSizeStart", placeholder: "请输入" },
            { val: "wordSizeEnd", placeholder: "请输入" },
          ],
        },
      ],
      inputData1: [
        // 传入组件的表单需要的数据格式
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
        },
        {
          name: "订单编号:",
          val: "orderId",
          placeholder: "请输入订单编号",
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
        },
        // {
        //     name: '买家账号:',
        //     val: 'nickName',
        //     placeholder: '请输入买家账号'
        // },
        {
          name: "回评状态:",
          val: "isVenderReply",
          selectArr: [
            { label: "未回复", id: 0 },
            { label: "京东后台回复", id: 1 },
            { label: "店长手动回复", id: 2 },
            { label: "店长自动回复", id: 3 },
          ],
        },
        {
          name: "评分等级:",
          val: "score",
          selectArr: [
            { label: "差评", id: 1 },
            { label: "中评", id: 2 },
            { label: "好评", id: 3 },
          ],
        },
        {
          name: "评价时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
        {
          name: "评价关键词:",
          val: "keyWord",
          placeholder: "请输入评价关键词，多个用','隔开",
        },
        {
          name: "评价内容:",
          val: "contentType",
          selectArr: [
            { label: "全部", id: "" },
            { label: "仅文字", id: 1 },
            { label: "含图片", id: 2 },
            { label: "含视频", id: 3 },
          ],
        },
        {
          name: "评价字数:",
          iptArr: [
            { val: "wordSizeStart", placeholder: "请输入" },
            { val: "wordSizeEnd", placeholder: "请输入" },
          ],
        },
      ],
      tableData: [
        // 表格数据
      ],
      loading: false,
      tableCheckAll: false, // 表格全选按钮
      // 分页配置信息
      current: 1,
      size: 10,
      total: 0,
      // 存储表格勾选的数据
      checkData: [],
      singleReplyState: false, // 单条数据回评弹窗
      singleReplyContent: null,
      singleReplyData: {
        // 存储点击的单条回复评价id
        commentIds: null,
        orderIds: null,
      },
      drawer: false, // 发送短信抽屉状态控制
      replyState: false, // 批量回复弹窗控制
      replyContent: null,
      // 黑名单弹窗控制
      joinBackListShow: false,
      showVideo: false,
      sendType: 1, // 发送类型 1. 按条件查询 2.勾选
      checkCount: 0,
      searchFormData: {}, // 存储按查询结果发送短信需要的查询参数
      videoData: {},
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 批量审核弹窗回评数量
    reviewNumber() {
      const notReview = this.checkData && this.checkData.filter((item) => item.isVenderReply == 0);
      return notReview.length;
    },
  },
  created(){
    // 埋点
    this.buriedPoint(1, '手动回评', '售后中心', '评价管理')
  },
  mounted() {
    this.$refs.searchForm.submitForm("formSearch");
  },
  methods: {
    toggleShow() {
      this.isShowAll = !this.isShowAll;
    },
    switchShowBugyer(val) {
      this.isShowAllBuyer = !this.isShowAllBuyer;
    },
    showVideoDialog(video) {
      this.videoData = video;
      this.showVideo = true;
    },
    handleSelectionChange(val) {
      console.log("val:", val);
      this.checkData = val;
    },
    // imageView () {
    //   const viewer = this.$el.querySelector('.images').$viewer
    //   viewer.show()
    // },
    /**
     * 查询
     */
    queryList(form, state) {
      this.loading = true;
      form.current = state ? 1 : this.current;
      form.size = this.size;
      this.searchFormData = form;
      getPopCommentReplyList(form).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          this.$message.error(res.data.message);
          return;
        }
        this.tableData = res && res.data.records;
        this.tableData.forEach((item) => {
          // item.checkVal = false;
          var count = 0;
          if (item.videoList && item.videoList.length > 0) {
            item.limit = 6 - item.videoList.length;
            item.videoLenth = item.videoList.leng;
            count += item.videoList.length;
          } else {
            item.limit = 6;
            item.videoLenth = 0;
          }
          if (item.imageList && item.imageList.length > 0) {
            count += item.imageList.length;
          }
          item.count = count;
        });
        this.total = res && res.data.total;
        this.$forceUpdate();
        this.loading = false;
        console.log(this.tableData);
      });
    },
    // 点击发送短信
    handleSendSms() {
      if (!this.checkData || this.checkData.length <= 0) {
        this.$message.warning("请先勾选订单");
        return;
      }
      if (!this.checkData || this.checkData.length < 2) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
        return;
      }
      this.sendType = 2;
      this.checkCount = this.checkData.length;
      this.drawer = true;
    },
    // 按查询结果发送短信
    handleSearchSendSms() {
      // if (this.tableData.length <= 0) return;
      if (this.tableData.length < 2) {
        this.$message.warning("京东官方规定人数少于2无法发送，请增加营销人数");
        return;
      }
      this.sendType = 1;
      this.checkCount = this.total;
      this.drawer = true;
    },
    // 批量加入黑名单弹窗显示
    handleAddBackList() {
      if (!this.checkData || this.checkData.length <= 0) {
        this.$message.warning("请先勾选订单");
        return;
      }
      console.log(this.checkData);
      this.joinBackListShow = true;
    },
    // 批量黑名单确定
    handleJoinBackList() {
      // return;
      let params = "";
      if (this.venderType) {
        console.log(this.checkData);
        params = {
          pins: this.checkData.map((item) => item.nickName),
          type: 1,
        };
      } else {
        params = {
          pins: this.checkData.map((item) => item.pin),
          type: 1,
        };
      }
      insertBlack(params).then((res) => {
        if (res && res.code == 1) {
          // this.$message.success("加入黑名单成功");
          this.$message.success("添加成功" + res.data.sucessNum + "个; 失败" + res.data.fialNum + "个");
          this.checkData = [];
          this.joinBackListShow = false;
          this.tableCheckAll = false;
          this.$refs.searchForm.submitForm("formSearch");
        }
      });
    },
    /**
     * 全选
     */
    checkAll(flag) {
      flag ? (this.checkData = this.tableData) : (this.checkData = []);
      console.log(this.checkData);

      this.tableData.forEach((item) => {
        if (flag) {
          item.checkVal = true;
        } else {
          item.checkVal = false;
        }
      });
    },
    /**
     * 单选
     */
    checkOne(flag, index) {
      if (flag) {
        console.log(this.tableData[index]);
        this.checkData.push(this.tableData[index]);
        const status = this.tableData.some((item) => item.checkVal === false);
        status ? (this.tableCheckAll = false) : (this.tableCheckAll = true);
      } else {
        this.checkData = this.checkData.filter((item) => {
          return item.orderId != this.tableData[index].orderId;
        });
        this.tableCheckAll = false;
      }
    },
    /**
     * 分页
     */
    handleSizeChange(val) {
      this.size = val;
      this.current = 1;
      this.$refs.searchForm.submitForm("formSearch");
    },
    handleCurrentChange(val) {
      this.current = val;
      this.$refs.searchForm.submitForm("formSearch");
    },
    // 单条回复评价点击
    singleReply(data) {
      this.singleReplyData.orderIds = [data.orderId];
      this.singleReplyData.commentIds = [data.commentId];
      this.singleReplyState = true;
    },
    // 单条回评弹窗隐藏
    singleReplyChange() {
      this.singleReplyState = false;
      this.singleReplyContent = null;
    },
    // 单条回评确认
    handleEditsingleReply() {
      if (this.singleReplyContent && this.singleReplyContent.trim()) {
        const params = {
          ...this.singleReplyData,
          replyContent: this.singleReplyContent,
        };
        replyCommentBatch(params).then((res) => {
          this.$message.success("回复成功");
          this.$refs.searchForm.submitForm("formSearch");

          this.singleReplyChange();
        });
      }
    },
    // 点击批量回复评价
    handleReview() {
      if (!this.checkData || this.checkData.length <= 0) {
        this.$message.warning("请先勾选订单");
        return;
      }
      this.replyState = true;
    },
    // 批量回复确认
    handleBatchReply() {
      if (!this.replyContent || !this.replyContent.trim()) return;
      // 判断选中的订单有没有包含未评价的订单
      const state = this.checkData.some((item) => item.isVenderReply == 0);
      if (!state) {
        this.$message.warning("勾选的订单都已回评");
        return;
      }
      const commentIds = this.checkData.map((item) => item.commentId);
      const orderIds = this.checkData.map((item) => item.orderId);
      replyCommentBatch({
        commentIds,
        orderIds,
        replyContent: this.replyContent,
      }).then((res) => {
        this.replyChange();
        this.$message.success("回复成功");
        this.$refs.searchForm.submitForm("formSearch");

        console.log(res);
      });
    },
    //
    replyChange() {
      this.replyState = false;
      this.replyContent = null;
    },
    /**
     * 发送短信抽屉隐藏
     */
    drawerClose() {
      this.drawer = false;
    },
  },
};
</script>

<style scoped lang="scss">
.manualReply {
  box-sizing: border-box;
  padding: 10px 20px 31px 20px;
  min-width: 1080px;
  .headForm {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    padding: 0 0 30px 0;
    border-radius: 6px;
    h4 {
      box-sizing: border-box;
      padding-left: 28px;
      margin: 0;
      height: 54px;
      line-height: 52px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
      color: #2e3458;
    }
  }
  //   .el-icon-close:before{
  // content: "\E6DB";
  // color: #fe4d45  !important;
  //     &:hover{
  //        color: #fe4d45  !important;
  //     }
  //   }
  .content {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .tableWrapper {
      margin-top: 20px;
      box-sizing: border-box;
      padding: 24px 28px 30px;
      .headBtn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        button {
          margin: 0;
          padding: 0 12px;
          height: 32px;
          // line-height: 30px;
          border: none;
          outline: none;
          border-radius: 3px;
          background-color: #fff;
          cursor: pointer;
          transition: all 0.2s;
        }
        .leftBtn {
          .b1 {
            background-color: #fe4d45;
            color: #fff;
            margin-right: 8px;
            &:hover {
              opacity: 0.9;
            }
          }
          .b2 {
            margin-right: 8px;
          }
          .b2,
          .b3 {
            border: 1px solid rgba(254, 77, 69, 1);
            color: #fe4d45;
            &:hover {
              background-color: #fe4d45;
              color: #fff;
            }
          }
          .b5 {
            border: 1px solid #ddd;
            color: #999;
            margin-right: 8px;
            &:hover {
              border: 1px solid #fe4d45;
              color: #fe4d45;
            }
          }
        }
      }
      .table {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        width: 100%;
        th {
          box-sizing: border-box;
          display: flex;
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding-left: 12px;
          text-align: left;
          background-color: #fafafa;
          font-size: 14px;
          color: #333;
        }
        tbody {
          display: flex;
          flex-direction: column;
          tr {
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding-left: 12px;
            margin-top: 16px;
            min-height: 120px;
            border-bottom: 1px solid rgba(246, 246, 246, 1);
            td {
              height: 100%;
            }
            p {
              margin: 0;
            }
            .info {
              flex: 6;
              display: flex;
              align-items: center;
              .right {
                .tit {
                  width: 90%;
                  font-size: 14px;
                  color: #666;
                }
                .details {
                  margin-top: 8px;
                  color: #999;
                  font-size: 14px;
                }
              }
            }
            .evaluate,
            .review {
              margin-bottom: 10px;
              padding-top: 10px;
              flex: 6;
              display: flex;
              flex-direction: column;
              justify-content: center;
              font-size: 14px;
              .desc {
                width: 90%;
                padding-bottom: 10px;
                color: #666;
              }
              .star {
                display: flex;
                align-items: center;
                margin: 4px 16px 4px 0;
                color: #999;
              }
              .user {
                color: #333;
                .name {
                  margin-right: 16px;
                }
              }
              .media-list {
                position: relative;
                .video-list {
                  // position: absolute;
                  // left: 0;
                  // top: 0;
                  // width: 64px;
                  // video {
                  //   width: 60px;
                  //   height: 60px;
                  //   border-radius: 8px;
                  //   overflow: hidden;
                  // }
                }
                .pic-list {
                  img:first-child {
                    margin-left: 68px;
                  }
                }
                & > div {
                  display: inline-block;
                  img {
                    border-radius: 8px;
                    overflow: hidden;
                    width: 60px;
                    height: 60px;
                    object-fit: cover;
                    margin-right: 8px;
                  }
                  video {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }
                }
              }
            }
            .review {
              .star {
                height: 23px;
              }
            }
            .operation {
              cursor: pointer;
              color: #7f85e9;
              &:hover {
                color: #fe4d45;
              }
            }
          }
        }
      }
      .pagination {
        margin-top: 20px;
        text-align: right;
      }
    }
  }
}
.replyContainer {
  box-sizing: border-box;
  padding-top: 20px;
  .item {
    display: flex;
    margin-bottom: 18px;
    .s {
      flex-shrink: 0;
      width: 75px;
    }
    .right {
      flex: 1;
      .desc {
        box-sizing: border-box;
        padding-left: 12px;
        margin-top: 8px;
        height: 42px;
        line-height: 40px;
        border-radius: 3px;
        background: #fafafa;
      }
    }
  }
  .footBtns {
    text-align: right;
    button {
      outline: none;
      border: none;
      border-radius: 3px;
      background-color: #fff;
    }
    .cancelBtn {
      width: 98px;
      height: 32px;
      // line-height: 30px;
      margin-right: 8px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #999;
      font-size: 14px;
      transition: all 0.2s;
      &:hover {
        border: 1px solid #fe4d45;
        color: #fe4d45;
      }
    }
    .confirmBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      background: rgba(254, 77, 69, 1);
      color: #fff;
      font-size: 14px;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.JoinBackList {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  .tipsBox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    .tips {
      width: 24px;
      height: 24px;
      margin-right: 10px;
    }
  }
  .btnBox {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      background-color: #fff;
      border: none;
      outline: none;
      border-radius: 3px;
      cursor: pointer;
    }
    .cancelBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      margin-right: 8px;
      border: 1px solid rgba(204, 204, 204, 1);
      color: #999;
      font-size: 14px;
      transition: all 0.2s;
      &:hover {
        border: 1px solid #fe4d45;
        color: #fe4d45;
      }
    }
    .confirmBtn {
      width: 98px;
      height: 32px;
      line-height: 30px;
      background: rgba(254, 77, 69, 1);
      color: #fff;
      font-size: 14px;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
/** ========== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active,
.fade-leave {
  opacity: 0;
}
.info {
  flex: 6;
  display: flex;
  align-items: center;
  .right {
    .tit {
      width: 90%;
      font-size: 14px;
      color: #666;
    }
    .details {
      margin-top: 8px;
      color: #999;
      font-size: 14px;
    }
  }
}
.evaluate,
.review {
  width: 420px;
  margin-bottom: 10px;
  padding-top: 10px;
  flex: 6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
  .desc {
    // width: 90%;
    width: 410px;
    margin-bottom: 10px;
    color: #666;
  }
  .one-ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .two-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .star {
    display: flex;
    align-items: center;
    margin: 4px 16px 4px 0;
    color: #999;
  }
  .user {
    color: #333;
    .name {
      margin-right: 16px;
    }
  }
  .media-list {
    position: relative;
    min-height: 60px;
    .video-list {
      position: absolute;
      left: 0;
      top: 0;
      .video-item {
        position: relative;
        display: inline-block;
        .mask {
          left: 0;
          top: 0;
          position: absolute;
        }
      }
    }
    .pic-list {
      img {
        cursor: pointer;
      }
      img:first-child {
        margin-left: 68px;
      }
      .total-box {
        position: absolute;
        width: 60px;
        height: 60px;
        background: #000;
        opacity: 0.8;
        border-radius: 8px;
        overflow: hidden;
        color: #fff;
        text-align: center;
        line-height: 60px;
        font-size: 12px;
        top: 0;
        right: 20px;
        pointer-events: none;
      }
    }
    & > div {
      display: inline-block;
      img {
        border-radius: 8px;
        overflow: hidden;
        width: 60px;
        height: 60px;
        object-fit: cover;
        margin-right: 8px;
      }
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.review {
  .star {
    height: 23px;
  }
}
</style>
